import { IAccountMappingMap } from '@modeso/types__aumico-lib-annualreport-be/dist/models/interfaces/IAccountMappingMap.interface';
import { otherOperatingExpensesAccounts } from './other-operating-expenses';
export const smeAccountPlan: IAccountMappingMap = {
    'cash-and-cash-equivalents': ['1000', '1010', '1020'],
    'accrued-assets': ['1300', '1301', '1302', '1303', '1304', '1305', '1306', '1307', '1308', '1309', '1310'],
    'financial-assets': ['1400', '1410', '1420', '1430', '1409', '1440', '1441', '1449'],
    'inventory-and-work-in-progress': ['1200', '1210', '1220', '1230', '1240', '1250', '1260', '1270', '1280'],
    investments: ['1480', '1489'],
    'long-term-interest-bearing-liablities': ['2400', '2410', '2420', '2430', '2450', '2451'],
    'other-receivables': ['1140', '1149', '1150', '1160', '1170', '1171', '1176', '1180', '1189', '1190', '1199'],
    'other-short-term-liablities': [
        '2200',
        '2201',
        '2206',
        '2208',
        '2210',
        '2220',
        '2230',
        '2240',
        '2250',
        '2261',
        '2270',
        '2279',
    ],
    share_capital: ['2800'],
    'personell-expenses': [
        '5000',
        '5001',
        '5002',
        '5003',
        '5004',
        '5005',
        '5006',
        '5007',
        '5008',
        '5009',
        '5010',
        '5011',
        '5012',
        '5013',
        '5014',
        '5015',
        '5016',
        '5017',
        '5018',
        '5019',
        '5020',
        '5021',
        '5022',
        '5023',
        '5024',
        '5025',
        '5026',
        '5027',
        '5028',
        '5029',
        '5030',
        '5031',
        '5032',
        '5033',
        '5034',
        '5035',
        '5036',
        '5037',
        '5038',
        '5039',
        '5040',
        '5041',
        '5042',
        '5043',
        '5044',
        '5045',
        '5046',
        '5047',
        '5048',
        '5049',
        '5050',
        '5051',
        '5052',
        '5053',
        '5054',
        '5055',
        '5056',
        '5057',
        '5058',
        '5059',
        '5060',
        '5061',
        '5062',
        '5063',
        '5064',
        '5065',
        '5066',
        '5067',
        '5068',
        '5069',
        '5070',
        '5071',
        '5072',
        '5073',
        '5074',
        '5075',
        '5076',
        '5077',
        '5078',
        '5079',
        '5080',
        '5081',
        '5082',
        '5083',
        '5084',
        '5085',
        '5086',
        '5087',
        '5088',
        '5089',
        '5090',
        '5091',
        '5092',
        '5093',
        '5094',
        '5095',
        '5096',
        '5097',
        '5098',
        '5099',
        '5100',
        '5101',
        '5102',
        '5103',
        '5104',
        '5105',
        '5106',
        '5107',
        '5108',
        '5109',
        '5110',
        '5111',
        '5112',
        '5113',
        '5114',
        '5115',
        '5116',
        '5117',
        '5118',
        '5119',
        '5120',
        '5121',
        '5122',
        '5123',
        '5124',
        '5125',
        '5126',
        '5127',
        '5128',
        '5129',
        '5130',
        '5131',
        '5132',
        '5133',
        '5134',
        '5135',
        '5136',
        '5137',
        '5138',
        '5139',
        '5140',
        '5141',
        '5142',
        '5143',
        '5144',
        '5145',
        '5146',
        '5147',
        '5148',
        '5149',
        '5150',
        '5151',
        '5152',
        '5153',
        '5154',
        '5155',
        '5156',
        '5157',
        '5158',
        '5159',
        '5160',
        '5161',
        '5162',
        '5163',
        '5164',
        '5165',
        '5166',
        '5167',
        '5168',
        '5169',
        '5170',
        '5171',
        '5172',
        '5173',
        '5174',
        '5175',
        '5176',
        '5177',
        '5178',
        '5179',
        '5180',
        '5181',
        '5182',
        '5183',
        '5184',
        '5185',
        '5186',
        '5187',
        '5188',
        '5189',
        '5190',
        '5191',
        '5192',
        '5193',
        '5194',
        '5195',
        '5196',
        '5197',
        '5198',
        '5199',
        '5200',
        '5201',
        '5202',
        '5203',
        '5204',
        '5205',
        '5206',
        '5207',
        '5208',
        '5209',
        '5210',
        '5211',
        '5212',
        '5213',
        '5214',
        '5215',
        '5216',
        '5217',
        '5218',
        '5219',
        '5220',
        '5221',
        '5222',
        '5223',
        '5224',
        '5225',
        '5226',
        '5227',
        '5228',
        '5229',
        '5230',
        '5231',
        '5232',
        '5233',
        '5234',
        '5235',
        '5236',
        '5237',
        '5238',
        '5239',
        '5240',
        '5241',
        '5242',
        '5243',
        '5244',
        '5245',
        '5246',
        '5247',
        '5248',
        '5249',
        '5250',
        '5251',
        '5252',
        '5253',
        '5254',
        '5255',
        '5256',
        '5257',
        '5258',
        '5259',
        '5260',
        '5261',
        '5262',
        '5263',
        '5264',
        '5265',
        '5266',
        '5267',
        '5268',
        '5269',
        '5270',
        '5271',
        '5272',
        '5273',
        '5274',
        '5275',
        '5276',
        '5277',
        '5278',
        '5279',
        '5280',
        '5281',
        '5282',
        '5283',
        '5284',
        '5285',
        '5286',
        '5287',
        '5288',
        '5289',
        '5290',
        '5291',
        '5292',
        '5293',
        '5294',
        '5295',
        '5296',
        '5297',
        '5298',
        '5299',
        '5300',
        '5301',
        '5302',
        '5303',
        '5304',
        '5305',
        '5306',
        '5307',
        '5308',
        '5309',
        '5310',
        '5311',
        '5312',
        '5313',
        '5314',
        '5315',
        '5316',
        '5317',
        '5318',
        '5319',
        '5320',
        '5321',
        '5322',
        '5323',
        '5324',
        '5325',
        '5326',
        '5327',
        '5328',
        '5329',
        '5330',
        '5331',
        '5332',
        '5333',
        '5334',
        '5335',
        '5336',
        '5337',
        '5338',
        '5339',
        '5340',
        '5341',
        '5342',
        '5343',
        '5344',
        '5345',
        '5346',
        '5347',
        '5348',
        '5349',
        '5350',
        '5351',
        '5352',
        '5353',
        '5354',
        '5355',
        '5356',
        '5357',
        '5358',
        '5359',
        '5360',
        '5361',
        '5362',
        '5363',
        '5364',
        '5365',
        '5366',
        '5367',
        '5368',
        '5369',
        '5370',
        '5371',
        '5372',
        '5373',
        '5374',
        '5375',
        '5376',
        '5377',
        '5378',
        '5379',
        '5380',
        '5381',
        '5382',
        '5383',
        '5384',
        '5385',
        '5386',
        '5387',
        '5388',
        '5389',
        '5390',
        '5391',
        '5392',
        '5393',
        '5394',
        '5395',
        '5396',
        '5397',
        '5398',
        '5399',
        '5400',
        '5401',
        '5402',
        '5403',
        '5404',
        '5405',
        '5406',
        '5407',
        '5408',
        '5409',
        '5410',
        '5411',
        '5412',
        '5413',
        '5414',
        '5415',
        '5416',
        '5417',
        '5418',
        '5419',
        '5420',
        '5421',
        '5422',
        '5423',
        '5424',
        '5425',
        '5426',
        '5427',
        '5428',
        '5429',
        '5430',
        '5431',
        '5432',
        '5433',
        '5434',
        '5435',
        '5436',
        '5437',
        '5438',
        '5439',
        '5440',
        '5441',
        '5442',
        '5443',
        '5444',
        '5445',
        '5446',
        '5447',
        '5448',
        '5449',
        '5450',
        '5451',
        '5452',
        '5453',
        '5454',
        '5455',
        '5456',
        '5457',
        '5458',
        '5459',
        '5460',
        '5461',
        '5462',
        '5463',
        '5464',
        '5465',
        '5466',
        '5467',
        '5468',
        '5469',
        '5470',
        '5471',
        '5472',
        '5473',
        '5474',
        '5475',
        '5476',
        '5477',
        '5478',
        '5479',
        '5480',
        '5481',
        '5482',
        '5483',
        '5484',
        '5485',
        '5486',
        '5487',
        '5488',
        '5489',
        '5490',
        '5491',
        '5492',
        '5493',
        '5494',
        '5495',
        '5496',
        '5497',
        '5498',
        '5499',
        '5500',
        '5501',
        '5502',
        '5503',
        '5504',
        '5505',
        '5506',
        '5507',
        '5508',
        '5509',
        '5510',
        '5511',
        '5512',
        '5513',
        '5514',
        '5515',
        '5516',
        '5517',
        '5518',
        '5519',
        '5520',
        '5521',
        '5522',
        '5523',
        '5524',
        '5525',
        '5526',
        '5527',
        '5528',
        '5529',
        '5530',
        '5531',
        '5532',
        '5533',
        '5534',
        '5535',
        '5536',
        '5537',
        '5538',
        '5539',
        '5540',
        '5541',
        '5542',
        '5543',
        '5544',
        '5545',
        '5546',
        '5547',
        '5548',
        '5549',
        '5550',
        '5551',
        '5552',
        '5553',
        '5554',
        '5555',
        '5556',
        '5557',
        '5558',
        '5559',
        '5560',
        '5561',
        '5562',
        '5563',
        '5564',
        '5565',
        '5566',
        '5567',
        '5568',
        '5569',
        '5570',
        '5571',
        '5572',
        '5573',
        '5574',
        '5575',
        '5576',
        '5577',
        '5578',
        '5579',
        '5580',
        '5581',
        '5582',
        '5583',
        '5584',
        '5585',
        '5586',
        '5587',
        '5588',
        '5589',
        '5590',
        '5591',
        '5592',
        '5593',
        '5594',
        '5595',
        '5596',
        '5597',
        '5598',
        '5599',
        '5600',
        '5601',
        '5602',
        '5603',
        '5604',
        '5605',
        '5606',
        '5607',
        '5608',
        '5609',
        '5610',
        '5611',
        '5612',
        '5613',
        '5614',
        '5615',
        '5616',
        '5617',
        '5618',
        '5619',
        '5620',
        '5621',
        '5622',
        '5623',
        '5624',
        '5625',
        '5626',
        '5627',
        '5628',
        '5629',
        '5630',
        '5631',
        '5632',
        '5633',
        '5634',
        '5635',
        '5636',
        '5637',
        '5638',
        '5639',
        '5640',
        '5641',
        '5642',
        '5643',
        '5644',
        '5645',
        '5646',
        '5647',
        '5648',
        '5649',
        '5650',
        '5651',
        '5652',
        '5653',
        '5654',
        '5655',
        '5656',
        '5657',
        '5658',
        '5659',
        '5660',
        '5661',
        '5662',
        '5663',
        '5664',
        '5665',
        '5666',
        '5667',
        '5668',
        '5669',
        '5670',
        '5671',
        '5672',
        '5673',
        '5674',
        '5675',
        '5676',
        '5677',
        '5678',
        '5679',
        '5680',
        '5681',
        '5682',
        '5683',
        '5684',
        '5685',
        '5686',
        '5687',
        '5688',
        '5689',
        '5690',
        '5691',
        '5692',
        '5693',
        '5694',
        '5695',
        '5696',
        '5697',
        '5698',
        '5699',
        '5700',
        '5701',
        '5702',
        '5703',
        '5704',
        '5705',
        '5706',
        '5707',
        '5708',
        '5709',
        '5710',
        '5711',
        '5712',
        '5713',
        '5714',
        '5715',
        '5716',
        '5717',
        '5718',
        '5719',
        '5720',
        '5721',
        '5722',
        '5723',
        '5724',
        '5725',
        '5726',
        '5727',
        '5728',
        '5729',
        '5730',
        '5731',
        '5732',
        '5733',
        '5734',
        '5735',
        '5736',
        '5737',
        '5738',
        '5739',
        '5740',
        '5741',
        '5742',
        '5743',
        '5744',
        '5745',
        '5746',
        '5747',
        '5748',
        '5749',
        '5750',
        '5751',
        '5752',
        '5753',
        '5754',
        '5755',
        '5756',
        '5757',
        '5758',
        '5759',
        '5760',
        '5761',
        '5762',
        '5763',
        '5764',
        '5765',
        '5766',
        '5767',
        '5768',
        '5769',
        '5770',
        '5771',
        '5772',
        '5773',
        '5774',
        '5775',
        '5776',
        '5777',
        '5778',
        '5779',
        '5780',
        '5781',
        '5782',
        '5783',
        '5784',
        '5785',
        '5786',
        '5787',
        '5788',
        '5789',
        '5790',
        '5791',
        '5792',
        '5793',
        '5794',
        '5795',
        '5796',
        '5797',
        '5798',
        '5799',
        '5800',
        '5801',
        '5802',
        '5803',
        '5804',
        '5805',
        '5806',
        '5807',
        '5808',
        '5809',
        '5810',
        '5811',
        '5812',
        '5813',
        '5814',
        '5815',
        '5816',
        '5817',
        '5818',
        '5819',
        '5820',
        '5821',
        '5822',
        '5823',
        '5824',
        '5825',
        '5826',
        '5827',
        '5828',
        '5829',
        '5830',
        '5831',
        '5832',
        '5833',
        '5834',
        '5835',
        '5836',
        '5837',
        '5838',
        '5839',
        '5840',
        '5841',
        '5842',
        '5843',
        '5844',
        '5845',
        '5846',
        '5847',
        '5848',
        '5849',
        '5850',
        '5851',
        '5852',
        '5853',
        '5854',
        '5855',
        '5856',
        '5857',
        '5858',
        '5859',
        '5860',
        '5861',
        '5862',
        '5863',
        '5864',
        '5865',
        '5866',
        '5867',
        '5868',
        '5869',
        '5870',
        '5871',
        '5872',
        '5873',
        '5874',
        '5875',
        '5876',
        '5877',
        '5878',
        '5879',
        '5880',
        '5881',
        '5882',
        '5883',
        '5884',
        '5885',
        '5886',
        '5887',
        '5888',
        '5889',
        '5890',
        '5891',
        '5892',
        '5893',
        '5894',
        '5895',
        '5896',
        '5897',
        '5898',
        '5899',
        '5900',
        '5901',
        '5902',
        '5903',
        '5904',
        '5905',
        '5906',
        '5907',
        '5908',
        '5909',
        '5910',
        '5911',
        '5912',
        '5913',
        '5914',
        '5915',
        '5916',
        '5917',
        '5918',
        '5919',
        '5920',
        '5921',
        '5922',
        '5923',
        '5924',
        '5925',
        '5926',
        '5927',
        '5928',
        '5929',
        '5930',
        '5931',
        '5932',
        '5933',
        '5934',
        '5935',
        '5936',
        '5937',
        '5938',
        '5939',
        '5940',
        '5941',
        '5942',
        '5943',
        '5944',
        '5945',
        '5946',
        '5947',
        '5948',
        '5949',
        '5950',
        '5951',
        '5952',
        '5953',
        '5954',
        '5955',
        '5956',
        '5957',
        '5958',
        '5959',
        '5960',
        '5961',
        '5962',
        '5963',
        '5964',
        '5965',
        '5966',
        '5967',
        '5968',
        '5969',
        '5970',
        '5971',
        '5972',
        '5973',
        '5974',
        '5975',
        '5976',
        '5977',
        '5978',
        '5979',
        '5980',
        '5981',
        '5982',
        '5983',
        '5984',
        '5985',
        '5986',
        '5987',
        '5988',
        '5989',
        '5990',
        '5991',
        '5992',
        '5993',
        '5994',
        '5995',
        '5996',
        '5997',
        '5998',
        '5999',
    ],
    'short-term-interest-bearing-liablities': ['2100', '2110', '2120', '2130', '2140'],
    'short-term-provisions': ['2310', '2320', '2330'],
    'accrued-liabilities': ['2300', '2301'],
    'long-term-provisions': [
        '2600',
        '2601',
        '2602',
        '2603',
        '2604',
        '2605',
        '2606',
        '2607',
        '2608',
        '2609',
        '2610',
        '2611',
        '2612',
        '2613',
        '2614',
        '2615',
        '2616',
        '2617',
        '2618',
        '2619',
        '2620',
        '2621',
        '2622',
        '2623',
        '2624',
        '2625',
        '2626',
        '2627',
        '2628',
        '2629',
        '2630',
        '2631',
        '2632',
        '2633',
        '2634',
        '2635',
        '2636',
        '2637',
        '2638',
        '2639',
        '2640',
        '2641',
        '2642',
        '2643',
        '2644',
        '2645',
        '2646',
        '2647',
        '2648',
        '2649',
        '2650',
        '2651',
        '2652',
        '2653',
        '2654',
        '2655',
        '2656',
        '2657',
        '2658',
        '2659',
        '2660',
        '2661',
        '2662',
        '2663',
        '2664',
        '2665',
        '2666',
        '2667',
        '2668',
        '2669',
        '2670',
        '2671',
        '2672',
        '2673',
        '2674',
        '2675',
        '2676',
        '2677',
        '2678',
        '2679',
        '2680',
        '2681',
        '2682',
        '2683',
        '2684',
        '2685',
        '2686',
        '2687',
        '2688',
        '2689',
        '2690',
        '2691',
        '2692',
        '2693',
        '2694',
        '2695',
        '2696',
        '2697',
        '2698',
        '2699',
    ],
    'trade-accounts-payable': ['2000', '2010', '2020', '2030'],
    'trade-receivables': ['1100', '1109'],
    'cost-of-material': [
        '4000',
        '4001',
        '4002',
        '4003',
        '4004',
        '4005',
        '4006',
        '4007',
        '4008',
        '4009',
        '4010',
        '4011',
        '4012',
        '4013',
        '4014',
        '4015',
        '4016',
        '4017',
        '4018',
        '4019',
        '4020',
        '4021',
        '4022',
        '4023',
        '4024',
        '4025',
        '4026',
        '4027',
        '4028',
        '4029',
        '4030',
        '4031',
        '4032',
        '4033',
        '4034',
        '4035',
        '4036',
        '4037',
        '4038',
        '4039',
        '4040',
        '4041',
        '4042',
        '4043',
        '4044',
        '4045',
        '4046',
        '4047',
        '4048',
        '4049',
        '4050',
        '4051',
        '4052',
        '4053',
        '4054',
        '4055',
        '4056',
        '4057',
        '4058',
        '4059',
        '4060',
        '4061',
        '4062',
        '4063',
        '4064',
        '4065',
        '4066',
        '4067',
        '4068',
        '4069',
        '4070',
        '4071',
        '4072',
        '4073',
        '4074',
        '4075',
        '4076',
        '4077',
        '4078',
        '4079',
        '4080',
        '4081',
        '4082',
        '4083',
        '4084',
        '4085',
        '4086',
        '4087',
        '4088',
        '4089',
        '4090',
        '4091',
        '4092',
        '4093',
        '4094',
        '4095',
        '4096',
        '4097',
        '4098',
        '4099',
        '4100',
        '4101',
        '4102',
        '4103',
        '4104',
        '4105',
        '4106',
        '4107',
        '4108',
        '4109',
        '4110',
        '4111',
        '4112',
        '4113',
        '4114',
        '4115',
        '4116',
        '4117',
        '4118',
        '4119',
        '4120',
        '4121',
        '4122',
        '4123',
        '4124',
        '4125',
        '4126',
        '4127',
        '4128',
        '4129',
        '4130',
        '4131',
        '4132',
        '4133',
        '4134',
        '4135',
        '4136',
        '4137',
        '4138',
        '4139',
        '4140',
        '4141',
        '4142',
        '4143',
        '4144',
        '4145',
        '4146',
        '4147',
        '4148',
        '4149',
        '4150',
        '4151',
        '4152',
        '4153',
        '4154',
        '4155',
        '4156',
        '4157',
        '4158',
        '4159',
        '4160',
        '4161',
        '4162',
        '4163',
        '4164',
        '4165',
        '4166',
        '4167',
        '4168',
        '4169',
        '4170',
        '4171',
        '4172',
        '4173',
        '4174',
        '4175',
        '4176',
        '4177',
        '4178',
        '4179',
        '4180',
        '4181',
        '4182',
        '4183',
        '4184',
        '4185',
        '4186',
        '4187',
        '4188',
        '4189',
        '4190',
        '4191',
        '4192',
        '4193',
        '4194',
        '4195',
        '4196',
        '4197',
        '4198',
        '4199',
        '4200',
        '4201',
        '4202',
        '4203',
        '4204',
        '4205',
        '4206',
        '4207',
        '4208',
        '4209',
        '4210',
        '4211',
        '4212',
        '4213',
        '4214',
        '4215',
        '4216',
        '4217',
        '4218',
        '4219',
        '4220',
        '4221',
        '4222',
        '4223',
        '4224',
        '4225',
        '4226',
        '4227',
        '4228',
        '4229',
        '4230',
        '4231',
        '4232',
        '4233',
        '4234',
        '4235',
        '4236',
        '4237',
        '4238',
        '4239',
        '4240',
        '4241',
        '4242',
        '4243',
        '4244',
        '4245',
        '4246',
        '4247',
        '4248',
        '4249',
        '4250',
        '4251',
        '4252',
        '4253',
        '4254',
        '4255',
        '4256',
        '4257',
        '4258',
        '4259',
        '4260',
        '4261',
        '4262',
        '4263',
        '4264',
        '4265',
        '4266',
        '4267',
        '4268',
        '4269',
        '4270',
        '4271',
        '4272',
        '4273',
        '4274',
        '4275',
        '4276',
        '4277',
        '4278',
        '4279',
        '4280',
        '4281',
        '4282',
        '4283',
        '4284',
        '4285',
        '4286',
        '4287',
        '4288',
        '4289',
        '4290',
        '4291',
        '4292',
        '4293',
        '4294',
        '4295',
        '4296',
        '4297',
        '4298',
        '4299',
        '4300',
        '4301',
        '4302',
        '4303',
        '4304',
        '4305',
        '4306',
        '4307',
        '4308',
        '4309',
        '4310',
        '4311',
        '4312',
        '4313',
        '4314',
        '4315',
        '4316',
        '4317',
        '4318',
        '4319',
        '4320',
        '4321',
        '4322',
        '4323',
        '4324',
        '4325',
        '4326',
        '4327',
        '4328',
        '4329',
        '4330',
        '4331',
        '4332',
        '4333',
        '4334',
        '4335',
        '4336',
        '4337',
        '4338',
        '4339',
        '4340',
        '4341',
        '4342',
        '4343',
        '4344',
        '4345',
        '4346',
        '4347',
        '4348',
        '4349',
        '4350',
        '4351',
        '4352',
        '4353',
        '4354',
        '4355',
        '4356',
        '4357',
        '4358',
        '4359',
        '4360',
        '4361',
        '4362',
        '4363',
        '4364',
        '4365',
        '4366',
        '4367',
        '4368',
        '4369',
        '4370',
        '4371',
        '4372',
        '4373',
        '4374',
        '4375',
        '4376',
        '4377',
        '4378',
        '4379',
        '4380',
        '4381',
        '4382',
        '4383',
        '4384',
        '4385',
        '4386',
        '4387',
        '4388',
        '4389',
        '4390',
        '4391',
        '4392',
        '4393',
        '4394',
        '4395',
        '4396',
        '4397',
        '4398',
        '4399',
        '4400',
        '4401',
        '4402',
        '4403',
        '4404',
        '4405',
        '4406',
        '4407',
        '4408',
        '4409',
        '4410',
        '4411',
        '4412',
        '4413',
        '4414',
        '4415',
        '4416',
        '4417',
        '4418',
        '4419',
        '4420',
        '4421',
        '4422',
        '4423',
        '4424',
        '4425',
        '4426',
        '4427',
        '4428',
        '4429',
        '4430',
        '4431',
        '4432',
        '4433',
        '4434',
        '4435',
        '4436',
        '4437',
        '4438',
        '4439',
        '4440',
        '4441',
        '4442',
        '4443',
        '4444',
        '4445',
        '4446',
        '4447',
        '4448',
        '4449',
        '4450',
        '4451',
        '4452',
        '4453',
        '4454',
        '4455',
        '4456',
        '4457',
        '4458',
        '4459',
        '4460',
        '4461',
        '4462',
        '4463',
        '4464',
        '4465',
        '4466',
        '4467',
        '4468',
        '4469',
        '4470',
        '4471',
        '4472',
        '4473',
        '4474',
        '4475',
        '4476',
        '4477',
        '4478',
        '4479',
        '4480',
        '4481',
        '4482',
        '4483',
        '4484',
        '4485',
        '4486',
        '4487',
        '4488',
        '4489',
        '4490',
        '4491',
        '4492',
        '4493',
        '4494',
        '4495',
        '4496',
        '4497',
        '4498',
        '4499',
        '4500',
        '4501',
        '4502',
        '4503',
        '4504',
        '4505',
        '4506',
        '4507',
        '4508',
        '4509',
        '4510',
        '4511',
        '4512',
        '4513',
        '4514',
        '4515',
        '4516',
        '4517',
        '4518',
        '4519',
        '4520',
        '4521',
        '4522',
        '4523',
        '4524',
        '4525',
        '4526',
        '4527',
        '4528',
        '4529',
        '4530',
        '4531',
        '4532',
        '4533',
        '4534',
        '4535',
        '4536',
        '4537',
        '4538',
        '4539',
        '4540',
        '4541',
        '4542',
        '4543',
        '4544',
        '4545',
        '4546',
        '4547',
        '4548',
        '4549',
        '4550',
        '4551',
        '4552',
        '4553',
        '4554',
        '4555',
        '4556',
        '4557',
        '4558',
        '4559',
        '4560',
        '4561',
        '4562',
        '4563',
        '4564',
        '4565',
        '4566',
        '4567',
        '4568',
        '4569',
        '4570',
        '4571',
        '4572',
        '4573',
        '4574',
        '4575',
        '4576',
        '4577',
        '4578',
        '4579',
        '4580',
        '4581',
        '4582',
        '4583',
        '4584',
        '4585',
        '4586',
        '4587',
        '4588',
        '4589',
        '4590',
        '4591',
        '4592',
        '4593',
        '4594',
        '4595',
        '4596',
        '4597',
        '4598',
        '4599',
        '4600',
        '4601',
        '4602',
        '4603',
        '4604',
        '4605',
        '4606',
        '4607',
        '4608',
        '4609',
        '4610',
        '4611',
        '4612',
        '4613',
        '4614',
        '4615',
        '4616',
        '4617',
        '4618',
        '4619',
        '4620',
        '4621',
        '4622',
        '4623',
        '4624',
        '4625',
        '4626',
        '4627',
        '4628',
        '4629',
        '4630',
        '4631',
        '4632',
        '4633',
        '4634',
        '4635',
        '4636',
        '4637',
        '4638',
        '4639',
        '4640',
        '4641',
        '4642',
        '4643',
        '4644',
        '4645',
        '4646',
        '4647',
        '4648',
        '4649',
        '4650',
        '4651',
        '4652',
        '4653',
        '4654',
        '4655',
        '4656',
        '4657',
        '4658',
        '4659',
        '4660',
        '4661',
        '4662',
        '4663',
        '4664',
        '4665',
        '4666',
        '4667',
        '4668',
        '4669',
        '4670',
        '4671',
        '4672',
        '4673',
        '4674',
        '4675',
        '4676',
        '4677',
        '4678',
        '4679',
        '4680',
        '4681',
        '4682',
        '4683',
        '4684',
        '4685',
        '4686',
        '4687',
        '4688',
        '4689',
        '4690',
        '4691',
        '4692',
        '4693',
        '4694',
        '4695',
        '4696',
        '4697',
        '4698',
        '4699',
        '4700',
        '4701',
        '4702',
        '4703',
        '4704',
        '4705',
        '4706',
        '4707',
        '4708',
        '4709',
        '4710',
        '4711',
        '4712',
        '4713',
        '4714',
        '4715',
        '4716',
        '4717',
        '4718',
        '4719',
        '4720',
        '4721',
        '4722',
        '4723',
        '4724',
        '4725',
        '4726',
        '4727',
        '4728',
        '4729',
        '4730',
        '4731',
        '4732',
        '4733',
        '4734',
        '4735',
        '4736',
        '4737',
        '4738',
        '4739',
        '4740',
        '4741',
        '4742',
        '4743',
        '4744',
        '4745',
        '4746',
        '4747',
        '4748',
        '4749',
        '4750',
        '4751',
        '4752',
        '4753',
        '4754',
        '4755',
        '4756',
        '4757',
        '4758',
        '4759',
        '4760',
        '4761',
        '4762',
        '4763',
        '4764',
        '4765',
        '4766',
        '4767',
        '4768',
        '4769',
        '4770',
        '4771',
        '4772',
        '4773',
        '4774',
        '4775',
        '4776',
        '4777',
        '4778',
        '4779',
        '4780',
        '4781',
        '4782',
        '4783',
        '4784',
        '4785',
        '4786',
        '4787',
        '4788',
        '4789',
        '4790',
        '4791',
        '4792',
        '4793',
        '4794',
        '4795',
        '4796',
        '4797',
        '4798',
        '4799',
        '4800',
        '4801',
        '4802',
        '4803',
        '4804',
        '4805',
        '4806',
        '4807',
        '4808',
        '4809',
        '4810',
        '4811',
        '4812',
        '4813',
        '4814',
        '4815',
        '4816',
        '4817',
        '4818',
        '4819',
        '4820',
        '4821',
        '4822',
        '4823',
        '4824',
        '4825',
        '4826',
        '4827',
        '4828',
        '4829',
        '4830',
        '4831',
        '4832',
        '4833',
        '4834',
        '4835',
        '4836',
        '4837',
        '4838',
        '4839',
        '4840',
        '4841',
        '4842',
        '4843',
        '4844',
        '4845',
        '4846',
        '4847',
        '4848',
        '4849',
        '4850',
        '4851',
        '4852',
        '4853',
        '4854',
        '4855',
        '4856',
        '4857',
        '4858',
        '4859',
        '4860',
        '4861',
        '4862',
        '4863',
        '4864',
        '4865',
        '4866',
        '4867',
        '4868',
        '4869',
        '4870',
        '4871',
        '4872',
        '4873',
        '4874',
        '4875',
        '4876',
        '4877',
        '4878',
        '4879',
        '4880',
        '4881',
        '4882',
        '4883',
        '4884',
        '4885',
        '4886',
        '4887',
        '4888',
        '4889',
        '4890',
        '4891',
        '4892',
        '4893',
        '4894',
        '4895',
        '4896',
        '4897',
        '4898',
        '4899',
        '4900',
        '4901',
        '4902',
        '4903',
        '4904',
        '4905',
        '4906',
        '4907',
        '4908',
        '4909',
        '4910',
        '4911',
        '4912',
        '4913',
        '4914',
        '4915',
        '4916',
        '4917',
        '4918',
        '4919',
        '4920',
        '4921',
        '4922',
        '4923',
        '4924',
        '4925',
        '4926',
        '4927',
        '4928',
        '4929',
        '4930',
        '4931',
        '4932',
        '4933',
        '4934',
        '4935',
        '4936',
        '4937',
        '4938',
        '4939',
        '4940',
        '4941',
        '4942',
        '4943',
        '4944',
        '4945',
        '4946',
        '4947',
        '4948',
        '4949',
        '4950',
        '4951',
        '4952',
        '4953',
        '4954',
        '4955',
        '4956',
        '4957',
        '4958',
        '4959',
        '4960',
        '4961',
        '4962',
        '4963',
        '4964',
        '4965',
        '4966',
        '4967',
        '4968',
        '4969',
        '4970',
        '4971',
        '4972',
        '4973',
        '4974',
        '4975',
        '4976',
        '4977',
        '4978',
        '4979',
        '4980',
        '4981',
        '4982',
        '4983',
        '4984',
        '4985',
        '4986',
        '4987',
        '4988',
        '4989',
        '4990',
        '4991',
        '4992',
        '4993',
        '4994',
        '4995',
        '4996',
        '4997',
        '4998',
        '4999',
    ],
    'fixed-assets': [
        '1500',
        '1509',
        '1510',
        '1519',
        '1520',
        '1529',
        '1530',
        '1539',
        '1540',
        '1549',
        '1550',
        '1560',
        '1570',
        '1580',
        '1590',
        '1600',
        '1609',
    ],
    'intangible-assets': ['1700', '1709', '1710', '1720', '1730', '1740', '1750', '1760', '1770', '1779'],
    'long-term-liabilities': ['2500'],
    'net-revenue': [
        '3000',
        '3001',
        '3002',
        '3003',
        '3004',
        '3005',
        '3006',
        '3007',
        '3008',
        '3009',
        '3010',
        '3011',
        '3012',
        '3013',
        '3014',
        '3015',
        '3016',
        '3017',
        '3018',
        '3019',
        '3020',
        '3021',
        '3022',
        '3023',
        '3024',
        '3025',
        '3026',
        '3027',
        '3028',
        '3029',
        '3030',
        '3031',
        '3032',
        '3033',
        '3034',
        '3035',
        '3036',
        '3037',
        '3038',
        '3039',
        '3040',
        '3041',
        '3042',
        '3043',
        '3044',
        '3045',
        '3046',
        '3047',
        '3048',
        '3049',
        '3050',
        '3051',
        '3052',
        '3053',
        '3054',
        '3055',
        '3056',
        '3057',
        '3058',
        '3059',
        '3060',
        '3061',
        '3062',
        '3063',
        '3064',
        '3065',
        '3066',
        '3067',
        '3068',
        '3069',
        '3070',
        '3071',
        '3072',
        '3073',
        '3074',
        '3075',
        '3076',
        '3077',
        '3078',
        '3079',
        '3080',
        '3081',
        '3082',
        '3083',
        '3084',
        '3085',
        '3086',
        '3087',
        '3088',
        '3089',
        '3090',
        '3091',
        '3092',
        '3093',
        '3094',
        '3095',
        '3096',
        '3097',
        '3098',
        '3099',
        '3100',
        '3101',
        '3102',
        '3103',
        '3104',
        '3105',
        '3106',
        '3107',
        '3108',
        '3109',
        '3110',
        '3111',
        '3112',
        '3113',
        '3114',
        '3115',
        '3116',
        '3117',
        '3118',
        '3119',
        '3120',
        '3121',
        '3122',
        '3123',
        '3124',
        '3125',
        '3126',
        '3127',
        '3128',
        '3129',
        '3130',
        '3131',
        '3132',
        '3133',
        '3134',
        '3135',
        '3136',
        '3137',
        '3138',
        '3139',
        '3140',
        '3141',
        '3142',
        '3143',
        '3144',
        '3145',
        '3146',
        '3147',
        '3148',
        '3149',
        '3150',
        '3151',
        '3152',
        '3153',
        '3154',
        '3155',
        '3156',
        '3157',
        '3158',
        '3159',
        '3160',
        '3161',
        '3162',
        '3163',
        '3164',
        '3165',
        '3166',
        '3167',
        '3168',
        '3169',
        '3170',
        '3171',
        '3172',
        '3173',
        '3174',
        '3175',
        '3176',
        '3177',
        '3178',
        '3179',
        '3180',
        '3181',
        '3182',
        '3183',
        '3184',
        '3185',
        '3186',
        '3187',
        '3188',
        '3189',
        '3190',
        '3191',
        '3192',
        '3193',
        '3194',
        '3195',
        '3196',
        '3197',
        '3198',
        '3199',
        '3200',
        '3201',
        '3202',
        '3203',
        '3204',
        '3205',
        '3206',
        '3207',
        '3208',
        '3209',
        '3210',
        '3211',
        '3212',
        '3213',
        '3214',
        '3215',
        '3216',
        '3217',
        '3218',
        '3219',
        '3220',
        '3221',
        '3222',
        '3223',
        '3224',
        '3225',
        '3226',
        '3227',
        '3228',
        '3229',
        '3230',
        '3231',
        '3232',
        '3233',
        '3234',
        '3235',
        '3236',
        '3237',
        '3238',
        '3239',
        '3240',
        '3241',
        '3242',
        '3243',
        '3244',
        '3245',
        '3246',
        '3247',
        '3248',
        '3249',
        '3250',
        '3251',
        '3252',
        '3253',
        '3254',
        '3255',
        '3256',
        '3257',
        '3258',
        '3259',
        '3260',
        '3261',
        '3262',
        '3263',
        '3264',
        '3265',
        '3266',
        '3267',
        '3268',
        '3269',
        '3270',
        '3271',
        '3272',
        '3273',
        '3274',
        '3275',
        '3276',
        '3277',
        '3278',
        '3279',
        '3280',
        '3281',
        '3282',
        '3283',
        '3284',
        '3285',
        '3286',
        '3287',
        '3288',
        '3289',
        '3290',
        '3291',
        '3292',
        '3293',
        '3294',
        '3295',
        '3296',
        '3297',
        '3298',
        '3299',
        '3300',
        '3301',
        '3302',
        '3303',
        '3304',
        '3305',
        '3306',
        '3307',
        '3308',
        '3309',
        '3310',
        '3311',
        '3312',
        '3313',
        '3314',
        '3315',
        '3316',
        '3317',
        '3318',
        '3319',
        '3320',
        '3321',
        '3322',
        '3323',
        '3324',
        '3325',
        '3326',
        '3327',
        '3328',
        '3329',
        '3330',
        '3331',
        '3332',
        '3333',
        '3334',
        '3335',
        '3336',
        '3337',
        '3338',
        '3339',
        '3340',
        '3341',
        '3342',
        '3343',
        '3344',
        '3345',
        '3346',
        '3347',
        '3348',
        '3349',
        '3350',
        '3351',
        '3352',
        '3353',
        '3354',
        '3355',
        '3356',
        '3357',
        '3358',
        '3359',
        '3360',
        '3361',
        '3362',
        '3363',
        '3364',
        '3365',
        '3366',
        '3367',
        '3368',
        '3369',
        '3370',
        '3371',
        '3372',
        '3373',
        '3374',
        '3375',
        '3376',
        '3377',
        '3378',
        '3379',
        '3380',
        '3381',
        '3382',
        '3383',
        '3384',
        '3385',
        '3386',
        '3387',
        '3388',
        '3389',
        '3390',
        '3391',
        '3392',
        '3393',
        '3394',
        '3395',
        '3396',
        '3397',
        '3398',
        '3399',
        '3400',
        '3401',
        '3402',
        '3403',
        '3404',
        '3405',
        '3406',
        '3407',
        '3408',
        '3409',
        '3410',
        '3411',
        '3412',
        '3413',
        '3414',
        '3415',
        '3416',
        '3417',
        '3418',
        '3419',
        '3420',
        '3421',
        '3422',
        '3423',
        '3424',
        '3425',
        '3426',
        '3427',
        '3428',
        '3429',
        '3430',
        '3431',
        '3432',
        '3433',
        '3434',
        '3435',
        '3436',
        '3437',
        '3438',
        '3439',
        '3440',
        '3441',
        '3442',
        '3443',
        '3444',
        '3445',
        '3446',
        '3447',
        '3448',
        '3449',
        '3450',
        '3451',
        '3452',
        '3453',
        '3454',
        '3455',
        '3456',
        '3457',
        '3458',
        '3459',
        '3460',
        '3461',
        '3462',
        '3463',
        '3464',
        '3465',
        '3466',
        '3467',
        '3468',
        '3469',
        '3470',
        '3471',
        '3472',
        '3473',
        '3474',
        '3475',
        '3476',
        '3477',
        '3478',
        '3479',
        '3480',
        '3481',
        '3482',
        '3483',
        '3484',
        '3485',
        '3486',
        '3487',
        '3488',
        '3489',
        '3490',
        '3491',
        '3492',
        '3493',
        '3494',
        '3495',
        '3496',
        '3497',
        '3498',
        '3499',
        '3500',
        '3501',
        '3502',
        '3503',
        '3504',
        '3505',
        '3506',
        '3507',
        '3508',
        '3509',
        '3510',
        '3511',
        '3512',
        '3513',
        '3514',
        '3515',
        '3516',
        '3517',
        '3518',
        '3519',
        '3520',
        '3521',
        '3522',
        '3523',
        '3524',
        '3525',
        '3526',
        '3527',
        '3528',
        '3529',
        '3530',
        '3531',
        '3532',
        '3533',
        '3534',
        '3535',
        '3536',
        '3537',
        '3538',
        '3539',
        '3540',
        '3541',
        '3542',
        '3543',
        '3544',
        '3545',
        '3546',
        '3547',
        '3548',
        '3549',
        '3550',
        '3551',
        '3552',
        '3553',
        '3554',
        '3555',
        '3556',
        '3557',
        '3558',
        '3559',
        '3560',
        '3561',
        '3562',
        '3563',
        '3564',
        '3565',
        '3566',
        '3567',
        '3568',
        '3569',
        '3570',
        '3571',
        '3572',
        '3573',
        '3574',
        '3575',
        '3576',
        '3577',
        '3578',
        '3579',
        '3580',
        '3581',
        '3582',
        '3583',
        '3584',
        '3585',
        '3586',
        '3587',
        '3588',
        '3589',
        '3590',
        '3591',
        '3592',
        '3593',
        '3594',
        '3595',
        '3596',
        '3597',
        '3598',
        '3599',
        '3600',
        '3601',
        '3602',
        '3603',
        '3604',
        '3605',
        '3606',
        '3607',
        '3608',
        '3609',
        '3610',
        '3611',
        '3612',
        '3613',
        '3614',
        '3615',
        '3616',
        '3617',
        '3618',
        '3619',
        '3620',
        '3621',
        '3622',
        '3623',
        '3624',
        '3625',
        '3626',
        '3627',
        '3628',
        '3629',
        '3630',
        '3631',
        '3632',
        '3633',
        '3634',
        '3635',
        '3636',
        '3637',
        '3638',
        '3639',
        '3640',
        '3641',
        '3642',
        '3643',
        '3644',
        '3645',
        '3646',
        '3647',
        '3648',
        '3649',
        '3650',
        '3651',
        '3652',
        '3653',
        '3654',
        '3655',
        '3656',
        '3657',
        '3658',
        '3659',
        '3660',
        '3661',
        '3662',
        '3663',
        '3664',
        '3665',
        '3666',
        '3667',
        '3668',
        '3669',
        '3670',
        '3671',
        '3672',
        '3673',
        '3674',
        '3675',
        '3676',
        '3677',
        '3678',
        '3679',
        '3680',
        '3681',
        '3682',
        '3683',
        '3684',
        '3685',
        '3686',
        '3687',
        '3688',
        '3689',
        '3690',
        '3691',
        '3692',
        '3693',
        '3694',
        '3695',
        '3696',
        '3697',
        '3698',
        '3699',
        '3700',
        '3701',
        '3702',
        '3703',
        '3704',
        '3705',
        '3706',
        '3707',
        '3708',
        '3709',
        '3710',
        '3711',
        '3712',
        '3713',
        '3714',
        '3715',
        '3716',
        '3717',
        '3718',
        '3719',
        '3720',
        '3721',
        '3722',
        '3723',
        '3724',
        '3725',
        '3726',
        '3727',
        '3728',
        '3729',
        '3730',
        '3731',
        '3732',
        '3733',
        '3734',
        '3735',
        '3736',
        '3737',
        '3738',
        '3739',
        '3740',
        '3741',
        '3742',
        '3743',
        '3744',
        '3745',
        '3746',
        '3747',
        '3748',
        '3749',
        '3750',
        '3751',
        '3752',
        '3753',
        '3754',
        '3755',
        '3756',
        '3757',
        '3758',
        '3759',
        '3760',
        '3761',
        '3762',
        '3763',
        '3764',
        '3765',
        '3766',
        '3767',
        '3768',
        '3769',
        '3770',
        '3771',
        '3772',
        '3773',
        '3774',
        '3775',
        '3776',
        '3777',
        '3778',
        '3779',
        '3780',
        '3781',
        '3782',
        '3783',
        '3784',
        '3785',
        '3786',
        '3787',
        '3788',
        '3789',
        '3790',
        '3791',
        '3792',
        '3793',
        '3794',
        '3795',
        '3796',
        '3797',
        '3798',
        '3799',
        '3800',
        '3801',
        '3802',
        '3803',
        '3804',
        '3805',
        '3806',
        '3807',
        '3808',
        '3809',
        '3810',
        '3811',
        '3812',
        '3813',
        '3814',
        '3815',
        '3816',
        '3817',
        '3818',
        '3819',
        '3820',
        '3821',
        '3822',
        '3823',
        '3824',
        '3825',
        '3826',
        '3827',
        '3828',
        '3829',
        '3830',
        '3831',
        '3832',
        '3833',
        '3834',
        '3835',
        '3836',
        '3837',
        '3838',
        '3839',
        '3840',
        '3841',
        '3842',
        '3843',
        '3844',
        '3845',
        '3846',
        '3847',
        '3848',
        '3849',
        '3850',
        '3851',
        '3852',
        '3853',
        '3854',
        '3855',
        '3856',
        '3857',
        '3858',
        '3859',
        '3860',
        '3861',
        '3862',
        '3863',
        '3864',
        '3865',
        '3866',
        '3867',
        '3868',
        '3869',
        '3870',
        '3871',
        '3872',
        '3873',
        '3874',
        '3875',
        '3876',
        '3877',
        '3878',
        '3879',
        '3880',
        '3881',
        '3882',
        '3883',
        '3884',
        '3885',
        '3886',
        '3887',
        '3888',
        '3889',
        '3890',
        '3891',
        '3892',
        '3893',
        '3894',
        '3895',
        '3896',
        '3897',
        '3898',
        '3899',
        '3900',
        '3901',
        '3902',
        '3903',
        '3904',
        '3905',
        '3906',
        '3907',
        '3908',
        '3909',
        '3910',
        '3911',
        '3912',
        '3913',
        '3914',
        '3915',
        '3916',
        '3917',
        '3918',
        '3919',
        '3920',
        '3921',
        '3922',
        '3923',
        '3924',
        '3925',
        '3926',
        '3927',
        '3928',
        '3929',
        '3930',
        '3931',
        '3932',
        '3933',
        '3934',
        '3935',
        '3936',
        '3937',
        '3938',
        '3939',
        '3940',
        '3941',
        '3942',
        '3943',
        '3944',
        '3945',
        '3946',
        '3947',
        '3948',
        '3949',
        '3950',
        '3951',
        '3952',
        '3953',
        '3954',
        '3955',
        '3956',
        '3957',
        '3958',
        '3959',
        '3960',
        '3961',
        '3962',
        '3963',
        '3964',
        '3965',
        '3966',
        '3967',
        '3968',
        '3969',
        '3970',
        '3971',
        '3972',
        '3973',
        '3974',
        '3975',
        '3976',
        '3977',
        '3978',
        '3979',
        '3980',
        '3981',
        '3982',
        '3983',
        '3984',
        '3985',
        '3986',
        '3987',
        '3988',
        '3989',
        '3990',
        '3991',
        '3992',
        '3993',
        '3994',
        '3995',
        '3996',
        '3997',
        '3998',
        '3999',
    ],
    'depreciation-and-amortization': [
        '6800',
        '6801',
        '6802',
        '6803',
        '6804',
        '6805',
        '6806',
        '6807',
        '6808',
        '6809',
        '6810',
        '6811',
        '6812',
        '6813',
        '6814',
        '6815',
        '6816',
        '6817',
        '6818',
        '6819',
        '6820',
        '6821',
        '6822',
        '6823',
        '6824',
        '6825',
        '6826',
        '6827',
        '6828',
        '6829',
        '6830',
        '6831',
        '6832',
        '6833',
        '6834',
        '6835',
        '6836',
        '6837',
        '6838',
        '6839',
        '6840',
        '6841',
        '6842',
        '6843',
        '6844',
        '6845',
        '6846',
        '6847',
        '6848',
        '6849',
        '6850',
        '6851',
        '6852',
        '6853',
        '6854',
        '6855',
        '6856',
        '6857',
        '6858',
        '6859',
        '6860',
        '6861',
        '6862',
        '6863',
        '6864',
        '6865',
        '6866',
        '6867',
        '6868',
        '6869',
        '6870',
        '6871',
        '6872',
        '6873',
        '6874',
        '6875',
        '6876',
        '6877',
        '6878',
        '6879',
        '6880',
        '6881',
        '6882',
        '6883',
        '6884',
        '6885',
        '6886',
        '6887',
        '6888',
        '6889',
        '6890',
        '6891',
        '6892',
        '6893',
        '6894',
        '6895',
        '6896',
        '6897',
        '6898',
        '6899',
    ],
    'financial-income': [
        '6950',
        '6951',
        '6952',
        '6953',
        '6954',
        '6955',
        '6956',
        '6957',
        '6958',
        '6959',
        '6960',
        '6961',
        '6962',
        '6963',
        '6964',
        '6965',
        '6966',
        '6967',
        '6968',
        '6969',
        '6970',
        '6971',
        '6972',
        '6973',
        '6974',
        '6975',
        '6976',
        '6977',
        '6978',
        '6979',
        '6980',
        '6981',
        '6982',
        '6983',
        '6984',
        '6985',
        '6986',
        '6987',
        '6988',
        '6989',
        '6990',
        '6991',
        '6992',
        '6993',
        '6994',
        '6995',
        '6996',
        '6997',
        '6998',
        '6999',
    ],
    'financial-expenses': [
        '6900',
        '6901',
        '6902',
        '6903',
        '6904',
        '6905',
        '6906',
        '6907',
        '6908',
        '6909',
        '6910',
        '6911',
        '6912',
        '6913',
        '6914',
        '6915',
        '6916',
        '6917',
        '6918',
        '6919',
        '6920',
        '6921',
        '6922',
        '6923',
        '6924',
        '6925',
        '6926',
        '6927',
        '6928',
        '6929',
        '6930',
        '6931',
        '6932',
        '6933',
        '6934',
        '6935',
        '6936',
        '6937',
        '6938',
        '6939',
        '6940',
        '6941',
        '6942',
        '6943',
        '6944',
        '6945',
        '6946',
        '6947',
        '6948',
        '6949',
    ],
    raumaufwand: [
        '6000',
        '6001',
        '6002',
        '6003',
        '6004',
        '6005',
        '6006',
        '6007',
        '6008',
        '6009',
        '6010',
        '6011',
        '6012',
        '6013',
        '6014',
        '6015',
        '6016',
        '6017',
        '6018',
        '6019',
        '6020',
        '6021',
        '6022',
        '6023',
        '6024',
        '6025',
        '6026',
        '6027',
        '6028',
        '6029',
        '6030',
        '6031',
        '6032',
        '6033',
        '6034',
        '6035',
        '6036',
        '6037',
        '6038',
        '6039',
        '6040',
        '6041',
        '6042',
        '6043',
        '6044',
        '6045',
        '6046',
        '6047',
        '6048',
        '6049',
        '6050',
        '6051',
        '6052',
        '6053',
        '6054',
        '6055',
        '6056',
        '6057',
        '6058',
        '6059',
        '6060',
        '6061',
        '6062',
        '6063',
        '6064',
        '6065',
        '6066',
        '6067',
        '6068',
        '6069',
        '6070',
        '6071',
        '6072',
        '6073',
        '6074',
        '6075',
        '6076',
        '6077',
        '6078',
        '6079',
        '6080',
        '6081',
        '6082',
        '6083',
        '6084',
        '6085',
        '6086',
        '6087',
        '6088',
        '6089',
        '6090',
        '6091',
        '6092',
        '6093',
        '6094',
        '6095',
        '6096',
        '6097',
        '6098',
        '6099',
    ],
    'Unterhalt, Reparaturen und Ersatz': [
        '6100',
        '6101',
        '6102',
        '6103',
        '6104',
        '6105',
        '6106',
        '6107',
        '6108',
        '6109',
        '6110',
        '6111',
        '6112',
        '6113',
        '6114',
        '6115',
        '6116',
        '6117',
        '6118',
        '6119',
        '6120',
        '6121',
        '6122',
        '6123',
        '6124',
        '6125',
        '6126',
        '6127',
        '6128',
        '6129',
        '6130',
        '6131',
        '6132',
        '6133',
        '6134',
        '6135',
        '6136',
        '6137',
        '6138',
        '6139',
        '6140',
        '6141',
        '6142',
        '6143',
        '6144',
        '6145',
        '6146',
        '6147',
        '6148',
        '6149',
        '6150',
        '6151',
        '6152',
        '6153',
        '6154',
        '6155',
        '6156',
        '6157',
        '6158',
        '6159',
        '6160',
        '6161',
        '6162',
        '6163',
        '6164',
        '6165',
        '6166',
        '6167',
        '6168',
        '6169',
        '6170',
        '6171',
        '6172',
        '6173',
        '6174',
        '6175',
        '6176',
        '6177',
        '6178',
        '6179',
        '6180',
        '6181',
        '6182',
        '6183',
        '6184',
        '6185',
        '6186',
        '6187',
        '6188',
        '6189',
        '6190',
        '6191',
        '6192',
        '6193',
        '6194',
        '6195',
        '6196',
        '6197',
        '6198',
        '6199',
    ],
    Fahrzeugaufwand: [
        '6200',
        '6201',
        '6202',
        '6203',
        '6204',
        '6205',
        '6206',
        '6207',
        '6208',
        '6209',
        '6210',
        '6211',
        '6212',
        '6213',
        '6214',
        '6215',
        '6216',
        '6217',
        '6218',
        '6219',
        '6220',
        '6221',
        '6222',
        '6223',
        '6224',
        '6225',
        '6226',
        '6227',
        '6228',
        '6229',
        '6230',
        '6231',
        '6232',
        '6233',
        '6234',
        '6235',
        '6236',
        '6237',
        '6238',
        '6239',
        '6240',
        '6241',
        '6242',
        '6243',
        '6244',
        '6245',
        '6246',
        '6247',
        '6248',
        '6249',
        '6250',
        '6251',
        '6252',
        '6253',
        '6254',
        '6255',
        '6256',
        '6257',
        '6258',
        '6259',
        '6260',
        '6261',
        '6262',
        '6263',
        '6264',
        '6265',
        '6266',
        '6267',
        '6268',
        '6269',
        '6270',
        '6271',
        '6272',
        '6273',
        '6274',
        '6275',
        '6276',
        '6277',
        '6278',
        '6279',
        '6280',
        '6281',
        '6282',
        '6283',
        '6284',
        '6285',
        '6286',
        '6287',
        '6288',
        '6289',
        '6290',
        '6291',
        '6292',
        '6293',
        '6294',
        '6295',
        '6296',
        '6297',
        '6298',
        '6299',
    ],
    'Sachversicherungen, Abgaben und Gebühren': [
        '6300',
        '6301',
        '6302',
        '6303',
        '6304',
        '6305',
        '6306',
        '6307',
        '6308',
        '6309',
        '6310',
        '6311',
        '6312',
        '6313',
        '6314',
        '6315',
        '6316',
        '6317',
        '6318',
        '6319',
        '6320',
        '6321',
        '6322',
        '6323',
        '6324',
        '6325',
        '6326',
        '6327',
        '6328',
        '6329',
        '6330',
        '6331',
        '6332',
        '6333',
        '6334',
        '6335',
        '6336',
        '6337',
        '6338',
        '6339',
        '6340',
        '6341',
        '6342',
        '6343',
        '6344',
        '6345',
        '6346',
        '6347',
        '6348',
        '6349',
        '6350',
        '6351',
        '6352',
        '6353',
        '6354',
        '6355',
        '6356',
        '6357',
        '6358',
        '6359',
        '6360',
        '6361',
        '6362',
        '6363',
        '6364',
        '6365',
        '6366',
        '6367',
        '6368',
        '6369',
        '6370',
        '6371',
        '6372',
        '6373',
        '6374',
        '6375',
        '6376',
        '6377',
        '6378',
        '6379',
        '6380',
        '6381',
        '6382',
        '6383',
        '6384',
        '6385',
        '6386',
        '6387',
        '6388',
        '6389',
        '6390',
        '6391',
        '6392',
        '6393',
        '6394',
        '6395',
        '6396',
        '6397',
        '6398',
        '6399',
    ],
    'Energie- und Entsorgungsaufwand': [
        '6400',
        '6401',
        '6402',
        '6403',
        '6404',
        '6405',
        '6406',
        '6407',
        '6408',
        '6409',
        '6410',
        '6411',
        '6412',
        '6413',
        '6414',
        '6415',
        '6416',
        '6417',
        '6418',
        '6419',
        '6420',
        '6421',
        '6422',
        '6423',
        '6424',
        '6425',
        '6426',
        '6427',
        '6428',
        '6429',
        '6430',
        '6431',
        '6432',
        '6433',
        '6434',
        '6435',
        '6436',
        '6437',
        '6438',
        '6439',
        '6440',
        '6441',
        '6442',
        '6443',
        '6444',
        '6445',
        '6446',
        '6447',
        '6448',
        '6449',
        '6450',
        '6451',
        '6452',
        '6453',
        '6454',
        '6455',
        '6456',
        '6457',
        '6458',
        '6459',
        '6460',
        '6461',
        '6462',
        '6463',
        '6464',
        '6465',
        '6466',
        '6467',
        '6468',
        '6469',
        '6470',
        '6471',
        '6472',
        '6473',
        '6474',
        '6475',
        '6476',
        '6477',
        '6478',
        '6479',
        '6480',
        '6481',
        '6482',
        '6483',
        '6484',
        '6485',
        '6486',
        '6487',
        '6488',
        '6489',
        '6490',
        '6491',
        '6492',
        '6493',
        '6494',
        '6495',
        '6496',
        '6497',
        '6498',
        '6499',
    ],
    'Verwaltungs- und Beratungsaufwand': [
        '6500',
        '6501',
        '6502',
        '6503',
        '6504',
        '6505',
        '6506',
        '6507',
        '6508',
        '6509',
        '6510',
        '6511',
        '6512',
        '6513',
        '6514',
        '6515',
        '6516',
        '6517',
        '6518',
        '6519',
        '6520',
        '6521',
        '6522',
        '6523',
        '6524',
        '6525',
        '6526',
        '6527',
        '6528',
        '6529',
        '6530',
        '6531',
        '6532',
        '6533',
        '6534',
        '6535',
        '6536',
        '6537',
        '6538',
        '6539',
        '6540',
        '6541',
        '6542',
        '6543',
        '6544',
        '6545',
        '6546',
        '6547',
        '6548',
        '6549',
        '6550',
        '6551',
        '6552',
        '6553',
        '6554',
        '6555',
        '6556',
        '6557',
        '6558',
        '6559',
        '6560',
        '6561',
        '6562',
        '6563',
        '6564',
        '6565',
        '6566',
        '6567',
        '6568',
        '6569',
    ],
    Informatikaufwand: [
        '6570',
        '6571',
        '6572',
        '6573',
        '6574',
        '6575',
        '6576',
        '6577',
        '6578',
        '6579',
        '6580',
        '6581',
        '6582',
        '6583',
        '6584',
        '6585',
        '6586',
        '6587',
        '6588',
        '6589',
        '6590',
        '6591',
        '6592',
        '6593',
        '6594',
        '6595',
        '6596',
        '6597',
        '6598',
        '6599',
    ],
    Werbeaufwand: [
        '6600',
        '6601',
        '6602',
        '6603',
        '6604',
        '6605',
        '6606',
        '6607',
        '6608',
        '6609',
        '6610',
        '6611',
        '6612',
        '6613',
        '6614',
        '6615',
        '6616',
        '6617',
        '6618',
        '6619',
        '6620',
        '6621',
        '6622',
        '6623',
        '6624',
        '6625',
        '6626',
        '6627',
        '6628',
        '6629',
        '6630',
        '6631',
        '6632',
        '6633',
        '6634',
        '6635',
        '6636',
        '6637',
        '6638',
        '6639',
        '6640',
        '6641',
        '6642',
        '6643',
        '6644',
        '6645',
        '6646',
        '6647',
        '6648',
        '6649',
        '6650',
        '6651',
        '6652',
        '6653',
        '6654',
        '6655',
        '6656',
        '6657',
        '6658',
        '6659',
        '6660',
        '6661',
        '6662',
        '6663',
        '6664',
        '6665',
        '6666',
        '6667',
        '6668',
        '6669',
        '6670',
        '6671',
        '6672',
        '6673',
        '6674',
        '6675',
        '6676',
        '6677',
        '6678',
        '6679',
        '6680',
        '6681',
        '6682',
        '6683',
        '6684',
        '6685',
        '6686',
        '6687',
        '6688',
        '6689',
        '6690',
        '6691',
        '6692',
        '6693',
        '6694',
        '6695',
        '6696',
        '6697',
        '6698',
        '6699',
    ],
    'Sonstiger betrieblicher Aufwand': [
        '6700',
        '6701',
        '6702',
        '6703',
        '6704',
        '6705',
        '6706',
        '6707',
        '6708',
        '6709',
        '6710',
        '6711',
        '6712',
        '6713',
        '6714',
        '6715',
        '6716',
        '6717',
        '6718',
        '6719',
        '6720',
        '6721',
        '6722',
        '6723',
        '6724',
        '6725',
        '6726',
        '6727',
        '6728',
        '6729',
        '6730',
        '6731',
        '6732',
        '6733',
        '6734',
        '6735',
        '6736',
        '6737',
        '6738',
        '6739',
        '6740',
        '6741',
        '6742',
        '6743',
        '6744',
        '6745',
        '6746',
        '6747',
        '6748',
        '6749',
        '6750',
        '6751',
        '6752',
        '6753',
        '6754',
        '6755',
        '6756',
        '6757',
        '6758',
        '6759',
        '6760',
        '6761',
        '6762',
        '6763',
        '6764',
        '6765',
        '6766',
        '6767',
        '6768',
        '6769',
        '6770',
        '6771',
        '6772',
        '6773',
        '6774',
        '6775',
        '6776',
        '6777',
        '6778',
        '6779',
        '6780',
        '6781',
        '6782',
        '6783',
        '6784',
        '6785',
        '6786',
        '6787',
        '6788',
        '6789',
        '6790',
        '6791',
        '6792',
        '6793',
        '6794',
        '6795',
        '6796',
        '6797',
        '6798',
        '6799',
    ],
    'share-capital': ['2800'],
    'profit-reserves': ['2960', '2961', '2962', '2963', '2964', '2965', '2966', '2967', '2968', '2969'],
    'legal-capital-reserves': [
        '2900',
        '2901',
        '2902',
        '2903',
        '2904',
        '2905',
        '2906',
        '2907',
        '2908',
        '2909',
        '2910',
        '2911',
        '2912',
        '2913',
        '2914',
        '2915',
        '2916',
        '2917',
        '2918',
        '2919',
        '2920',
        '2921',
        '2922',
        '2923',
        '2924',
        '2925',
        '2926',
        '2927',
        '2928',
        '2929',
        '2930',
        '2931',
        '2932',
        '2933',
        '2934',
        '2935',
        '2936',
        '2937',
        '2938',
        '2939',
    ],
    'legal-profit-reserves': ['2950', '2951', '2952', '2953', '2954', '2955', '2956', '2957', '2958', '2959'],
    profit_brought_forward: ['2970', '2971', '2972', '2973', '2974', '2975', '2976', '2977', '2978'],
    'direct-taxes': [
        '8900',
        '8901',
        '8902',
        '8903',
        '8904',
        '8905',
        '8906',
        '8907',
        '8908',
        '8909',
        '8910',
        '8911',
        '8912',
        '8913',
        '8914',
        '8915',
        '8916',
        '8917',
        '8918',
        '8919',
        '8920',
        '8921',
        '8922',
        '8923',
        '8924',
        '8925',
        '8926',
        '8927',
        '8928',
        '8929',
        '8930',
        '8931',
        '8932',
        '8933',
        '8934',
        '8935',
        '8936',
        '8937',
        '8938',
        '8939',
        '8940',
        '8941',
        '8942',
        '8943',
        '8944',
        '8945',
        '8946',
        '8947',
        '8948',
        '8949',
        '8950',
        '8951',
        '8952',
        '8953',
        '8954',
        '8955',
        '8956',
        '8957',
        '8958',
        '8959',
        '8960',
        '8961',
        '8962',
        '8963',
        '8964',
        '8965',
        '8966',
        '8967',
        '8968',
        '8969',
        '8970',
        '8971',
        '8972',
        '8973',
        '8974',
        '8975',
        '8976',
        '8977',
        '8978',
        '8979',
        '8980',
        '8981',
        '8982',
        '8983',
        '8984',
        '8985',
        '8986',
        '8987',
        '8988',
        '8989',
        '8990',
        '8991',
        '8992',
        '8993',
        '8994',
        '8995',
        '8996',
        '8997',
        '8998',
        '8999',
    ],
    'other-operating-expenses': otherOperatingExpensesAccounts,
};

/**
 * Account numbers the SME automapping matches EXACTLY (all digits), not by the 3-digit prefix of
 * `smeAccountPlan` — so a neighbour like 9201 stays untouched.
 *
 * 9200 "Jahresgewinn/-verlust (Erfolgsrechnung)" is the closing account of class 9. An ERP that books the
 * profit appropriation in the year itself (PROFFIX demo, REV-22536) leaves it with the counter amount of
 * that appropriation; the import puts it in the balance sheet (equity), and mapping it to the retained
 * earnings makes the balance sheet tie while aumico still transfers the year result itself. Only the
 * balance-sheet template has `profit_brought_forward`, so a 9200 in the income statement stays unmapped.
 * The user can re-map it by hand.
 */
export const smeAccountPlanExactNumbers: IAccountMappingMap = {
    profit_brought_forward: ['9200'],
};
